import { createFileRoute } from "@tanstack/react-router";
import { Layout } from "@/components/Layout";
import { useState } from "react";
import { buildContactLd } from "@/lib/page-schemas";

export const Route = createFileRoute("/contact")({
  head: () => ({
    meta: [
      { title: "Contact Us — DrHint" },
      { name: "description", content: "Get in touch with the DrHint team. Send feedback, corrections or city requests." },
      { property: "og:title", content: "Contact DrHint" },
      { property: "og:description", content: "Send feedback, corrections or city requests." },
      { property: "og:url", content: "https://drhint.com/contact" },
    ],
    links: [{ rel: "canonical", href: "https://drhint.com/contact" }],
    scripts: buildContactLd({
      url: "https://drhint.com/contact",
      name: "Contact DrHint",
      description: "Send feedback, corrections or new-city requests to the DrHint editorial team.",
      email: "attapops4@gmail.com",
      trail: [
        { name: "Home", item: "https://drhint.com/" },
        { name: "Contact", item: "https://drhint.com/contact" },
      ],
    }),
  }),
  component: ContactPage,
});

function ContactPage() {
  const [submitted, setSubmitted] = useState(false);
  return (
    <Layout>
      <section className="mx-auto max-w-2xl px-4 py-10">
        <h1 className="text-3xl font-bold">Contact Us</h1>
        <p className="mt-3 text-muted-foreground">
          Have a correction, a city request, or general feedback? Send us a message — we read every one.
          You can also reach us directly at{" "}
          <a href="mailto:attapops4@gmail.com" className="text-primary underline">attapops4@gmail.com</a>.
        </p>

        {submitted ? (
          <div className="mt-8 rounded-xl border border-border bg-card p-6 text-center">
            <div className="text-lg font-semibold">Thank you!</div>
            <p className="mt-2 text-sm text-muted-foreground">
              Your message has been received. We typically reply within 2 business days.
            </p>
          </div>
        ) : (
          <form
            className="mt-8 space-y-4"
            onSubmit={(e) => {
              e.preventDefault();
              setSubmitted(true);
            }}
          >
            <div>
              <label className="block text-sm font-medium mb-1" htmlFor="name">Your name</label>
              <input id="name" name="name" required className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm" />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1" htmlFor="email">Email</label>
              <input id="email" name="email" type="email" required className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm" />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1" htmlFor="message">Message</label>
              <textarea id="message" name="message" rows={5} required className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm" />
            </div>
            <button
              type="submit"
              className="rounded-lg px-5 py-2.5 text-sm font-semibold text-primary-foreground"
              style={{ background: "var(--gradient-gold)" }}
            >
              Send message
            </button>
          </form>
        )}
      </section>
    </Layout>
  );
}